import { DurationUnit } from '@wix/ambassador-premium-cart-v1-cart/types';
import { ArrayUtils, constants, mappers } from '@wix/premium-cart-common';
import { cyclePriceDisplayPropsFromProductPricing } from '../../premium-pricing-api-client';
const enrichPriceSummmary = props => {
  var _pricingInfo$salePric, _lineItem$priceSummar, _lineItem$cycle;
  const {
    lineItem,
    currencySettings,
    pricingInfo
  } = props;
  if (!lineItem.cycle) {
    // TODO - error handling
    throw new Error('line item has no cycle');
  }
  const cycle = mappers.CartCycleToDynamicCycle(lineItem.cycle);
  if (!cycle.interval) {
    // TODO - error handling
    throw new Error('cycle has no valid interval');
  }
  const quantity = lineItem.seats ?? 1;
  const interval = cycle.interval;

  // Find maximal pricing per month
  const {
    maximalTotalPriceDecimal,
    totalSavingsDecimal
  } = cyclePriceDisplayPropsFromProductPricing({
    interval,
    salePricing: pricingInfo == null || (_pricingInfo$salePric = pricingInfo.salePricing) == null ? void 0 : _pricingInfo$salePric.discountPrices,
    catalogPricing: (pricingInfo == null ? void 0 : pricingInfo.catalogPricing) ?? [],
    currencySettings: currencySettings ?? {},
    quantity
  });
  if (!((_lineItem$priceSummar = lineItem.priceSummary) != null && _lineItem$priceSummar.subTotal)) {
    // TODO - error handling
    throw new Error('Seasonal sale but no subtotal price from cart');
  }
  if (!lineItem.priceSummary.beforeTax) {
    // TODO - error handling
    throw new Error('Seasonal sale but no subtotal price from cart');
  }

  // When sale all data come from cart service
  return {
    ...lineItem.priceSummary,
    noSale: {
      maximalPrice: (lineItem == null || (_lineItem$cycle = lineItem.cycle) == null || (_lineItem$cycle = _lineItem$cycle.cycleDuration) == null ? void 0 : _lineItem$cycle.unit) === DurationUnit.MONTH ? undefined : maximalTotalPriceDecimal,
      savingsAmount: totalSavingsDecimal
    },
    sale: {
      maximalPrice: lineItem.priceSummary.subTotal,
      savingsAmount: Number(lineItem.priceSummary.subTotal) - Number(lineItem.priceSummary.beforeTax)
    }
  };
};
const enrichCart = props => {
  const {
    cart,
    userOfferings
  } = props;
  const lineItems = cart.lineItems;
  let cartSumSavings = 0;
  const enrichedLineItems = (lineItems ?? []).filter(lineItem => lineItem.id).map(lineItem => {
    var _userOffering$product, _lineItem$discountInf, _userOffering$display;
    const productTypeIdUserOffering = userOfferings == null ? void 0 : userOfferings.find(userOfferingRes => {
      var _lineItem$productInfo;
      return userOfferingRes.productTypeId === ((_lineItem$productInfo = lineItem.productInfo) == null ? void 0 : _lineItem$productInfo.productTypeId);
    });
    const userOffering = productTypeIdUserOffering == null ? void 0 : productTypeIdUserOffering.userOffering;
    const productInfo = userOffering == null || (_userOffering$product = userOffering.products) == null ? void 0 : _userOffering$product.find(product => {
      var _lineItem$productInfo2;
      return product.productId === ((_lineItem$productInfo2 = lineItem.productInfo) == null ? void 0 : _lineItem$productInfo2.productId);
    });
    const enrichedPriceSummary = enrichPriceSummmary({
      lineItem,
      currencySettings: userOffering == null ? void 0 : userOffering.currencySettings,
      pricingInfo: productInfo == null ? void 0 : productInfo.pricingInfo
    });
    const isLineItemInSale = (lineItem == null || (_lineItem$discountInf = lineItem.discountInfo) == null || (_lineItem$discountInf = _lineItem$discountInf.sale) == null ? void 0 : _lineItem$discountInf.saleType) === constants.SaleTypes.Seasonal;
    cartSumSavings += isLineItemInSale ? enrichedPriceSummary.sale.savingsAmount : enrichedPriceSummary.noSale.savingsAmount;
    return {
      ...lineItem,
      priceSummary: enrichedPriceSummary,
      productDisplayName: productInfo == null ? void 0 : productInfo.name,
      productTypeDisplayName: userOffering == null || (_userOffering$display = userOffering.displayProperties) == null ? void 0 : _userOffering$display.name,
      sbsProductId: productInfo == null ? void 0 : productInfo.sbsProductIdPoc
    };
  });
  return {
    cart: {
      ...cart,
      totalAmounts: {
        ...cart.totalAmounts,
        savingsAmount: cartSumSavings
      },
      lineItems: ArrayUtils.reduceById(enrichedLineItems)
    }
  };
};
async function dynamicLoadCartQueries(httpClient) {
  return (await import('../premium-cart.api-client')).PremiumCartInternalApiClient.queries({
    httpClient
  });
}
async function dynamicLoadCartApiClient() {
  return (await import('../premium-cart.api-client')).PremiumCartInternalApiClient;
}
export const CartApiClientUtils = {
  enrichCart,
  dynamicLoadCartQueries,
  dynamicLoadCartApiClient
};
//# sourceMappingURL=cart-api-client.utils.js.map